import React from 'react';
import { CinematicHero } from './CinematicHero';
export function Hero() {
  return <CinematicHero data-id="element-235" />;
}